/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetBankAccountActivities200ResponseAppliedBy } from './get-bank-account-activities200-response-applied-by';

/**
 * 
 * @export
 * @interface GetBankAccountActivities200Response
 */
export interface GetBankAccountActivities200Response {
    /**
     * 
     * @type {string}
     * @memberof GetBankAccountActivities200Response
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetBankAccountActivities200Response
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetBankAccountActivities200Response
     */
    'organizationName': string;
    /**
     * 
     * @type {string}
     * @memberof GetBankAccountActivities200Response
     */
    'type': GetBankAccountActivities200ResponseTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetBankAccountActivities200Response
     */
    'status': GetBankAccountActivities200ResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof GetBankAccountActivities200Response
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof GetBankAccountActivities200Response
     */
    'supplierName': string;
    /**
     * 
     * @type {number}
     * @memberof GetBankAccountActivities200Response
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof GetBankAccountActivities200Response
     */
    'pointAmount': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetBankAccountActivities200Response
     */
    'balance': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetBankAccountActivities200Response
     */
    'pointBalance': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetBankAccountActivities200Response
     */
    'isConfirmed': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetBankAccountActivities200Response
     */
    'appliedAt': string | null;
    /**
     * 
     * @type {GetBankAccountActivities200ResponseAppliedBy}
     * @memberof GetBankAccountActivities200Response
     */
    'appliedBy': GetBankAccountActivities200ResponseAppliedBy;
    /**
     * 
     * @type {string}
     * @memberof GetBankAccountActivities200Response
     */
    'executedAt': string | null;
}

export const GetBankAccountActivities200ResponseTypeEnum = {
    payBill: 'PAY_BILL',
    deposit: 'DEPOSIT',
    withdrawal: 'WITHDRAWAL',
    reward: 'REWARD',
    usageFee: 'USAGE_FEE',
    point: 'POINT',
    cardPoint: 'CARD_POINT',
    campaignPoint: 'CAMPAIGN_POINT',
    card: 'CARD',
    depositFromGuaranteeMoney: 'DEPOSIT_FROM_GUARANTEE_MONEY',
    withdrawalToGuaranteeMoney: 'WITHDRAWAL_TO_GUARANTEE_MONEY',
    serviceCharge: 'SERVICE_CHARGE'
} as const;

export type GetBankAccountActivities200ResponseTypeEnum = typeof GetBankAccountActivities200ResponseTypeEnum[keyof typeof GetBankAccountActivities200ResponseTypeEnum];
export const GetBankAccountActivities200ResponseStatusEnum = {
    reserved: 'RESERVED',
    requestingExternalAccountTransfer: 'REQUESTING_EXTERNAL_ACCOUNT_TRANSFER',
    completed: 'COMPLETED',
    insufficientBalance: 'INSUFFICIENT_BALANCE',
    uploaded: 'UPLOADED',
    readCompleted: 'READ_COMPLETED',
    awaitingApproval: 'AWAITING_APPROVAL',
    approved: 'APPROVED',
    transferCompleted: 'TRANSFER_COMPLETED',
    readError: 'READ_ERROR',
    transferFailed: 'TRANSFER_FAILED',
    approvalExpired: 'APPROVAL_EXPIRED',
    approvalRejected: 'APPROVAL_REJECTED',
    otherError: 'OTHER_ERROR',
    pending: 'PENDING'
} as const;

export type GetBankAccountActivities200ResponseStatusEnum = typeof GetBankAccountActivities200ResponseStatusEnum[keyof typeof GetBankAccountActivities200ResponseStatusEnum];


